<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'App'
  }
</script>
<style lang="scss" scoped>

#app{
    /deep/ .el-table th{
      user-select:inherit !important;
    }
    /deep/ .el-table th{
      user-select:inherit !important;
    }
    /deep/ .tableLabelHidden{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
    .overHText{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    // /deep/ .el-card__body{
    //   .el-form {
    //     display: flex;
    //     align-items: center;
    //     flex-wrap: wrap;
    //     justify-content: flex-start;
    //     .el-form-item{
    //       display: flex;
    //       align-items: center;
    //       width: 20%;
    //     }
    //   }
    // }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue